<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="
			modelId > 0
				? 'Edición categoria de servicio'
				: 'Nuevo categoria de servicio'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-tabs
			no-fade
			pills
			card
			small
			vertical
			nav-class="nav-style"
			align="center"
		>
			<b-tab title="General" active>
				<b-form @submit="onSubmit">
					<b-form-row>
						<b-form-group
							:disabled="unableEdit"
							class="col-4"
							label="Codigo"
						>
							<b-form-input
								type="text"
								size="sm"
								v-model="modelInfo.code"
								required
							/>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-4"
							label="Nombre"
						>
							<b-form-input
								type="text"
								size="sm"
								v-model="modelInfo.name"
								required
							/>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-4"
							label="Estado"
						>
							<b-form-select
								size="sm"
								v-model="modelInfo.status"
								:options="statusOptions"
								required
							></b-form-select>
						</b-form-group>
					</b-form-row>

					<b-form-row>
						<b-form-group
							class="col-12"
							label="Descripcion general"
						>
							<b-textarea
								size="sm"
								:disabled="unableEdit"
								v-model="modelInfo.description"
							/>
						</b-form-group>
					</b-form-row>
					<hr />
					<div class="text-right">
						<b-button
							:disabled="unableEdit"
							variant="primary"
							type="submit"
							>{{
								modelId > 0 ? "Actualizar" : "Guardar"
							}}</b-button
						>
					</div>
				</b-form>
			</b-tab>
		</b-tabs>
	</b-modal>
</template>

<script>
export default {
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {},
	data() {
		const defaultModelInfo = {
			id: -1,
			code: "",
			name: "",
			status: 'active',
			description: ""
		};
		return {
			modelId: -1,
			loading: true,
			modelInfo: { ...defaultModelInfo },
			defaultModelInfo: { ...defaultModelInfo },
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			]
		};
	},
	computed: {
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/service-types-categories/${this.modelId}`
						: "/service-types-categories",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert("OK!");
					this.$root.auxVars.resetResource("serviceTypesCategories");
					this.$root.auxVars.loadResourcesOpts({
						vm: this,
						resourceNames: ["serviceTypesCategories"],
						forceRefresh: true
					});
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},

		loadServiceType(id) {
			return this.$root.api.get(`/service-types-categories/${id}`);
		},

		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.loadServiceType(this.modelId)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		}
	}
};
</script>

<style></style>
